import gql from 'graphql-tag';
import client from '../../common/graphql/apollo';

export const updateDraftInfoMutation = (
  id,
  nameDraft,
  thumbnailDraft,
  lastUpdatedBy,
) =>
  client.mutate({
    mutation: gql`
      mutation updatePresentation(
        $id: UUID!
        $nameDraft: String
        $thumbnailDraft: String
        $lastUpdatedBy: UUID
      ) {
        updatePresentation(
          input: {
            id: $id
            nameDraft: $nameDraft
            thumbnailDraft: $thumbnailDraft
            lastUpdatedBy: $lastUpdatedBy
          }
        ) {
          success
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      id,
      nameDraft,
      thumbnailDraft,
      lastUpdatedBy,
    },
  });

export const updatePublicInfoMutation = ({ id, name, value }) =>
  client.mutate({
    mutation: gql`
      mutation updatePresentation(
        $id: UUID!
        $${name}: String
      ) {
        updatePresentation(
          input: { id: $id, ${name}: $${name}, }
        ) {
          success
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      id,
      [name]: value,
    },
  });

export const updateVisibilityMutation = ({ id, name, value }) =>
  client.mutate({
    mutation: gql`
    mutation updatePresentation($id: UUID!, $${name}: Boolean) {
      updatePresentation(input: {id: $id, ${name}: $${name}}) {
        success
        validationErrors {
          field
          code
          message
          extra
        }
      }
    }
  `,
    variables: {
      id,
      [name]: value,
    },
  });

export const createSymbolMutation = (name, content, tags, team) =>
  client.mutate({
    mutation: gql`
      mutation createSymbol(
        $name: String
        $content: String!
        $tags: [String]
        $team: UUID
      ) {
        createSymbol(
          input: { name: $name, content: $content, tags: $tags, team: $team }
        ) {
          success
          symbol {
            id
            name
            content
          }
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      name,
      content,
      tags,
      team,
    },
  });

export const updateSymbolMutation = async (id, name, content, tags, team) => {
  return client.mutate({
    mutation: gql`
      mutation updateSymbol(
        $id: UUID!
        $name: String
        $content: String!
        $tags: [String]
        $team: UUID
      ) {
        updateSymbol(
          input: {
            id: $id
            name: $name
            content: $content
            tags: $tags
            team: $team
          }
        ) {
          success
          symbol {
            id
            name
            content
          }
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      id,
      name,
      content,
      tags,
      team,
    },
  });
};

export const saveTemplateMutation = (
  id,
  themeId,
  version,
  content,
  type,
  name,
  width,
  height,
  team,
  thumbnail,
) =>
  client.mutate({
    mutation: gql`
      mutation saveTemplate(
        $id: UUID!
        $themeId: UUID
        $version: String
        $content: GenericScalar!
        $type: TemplateType!
        $name: String
        $width: Int!
        $height: Int!
        $team: UUID
        $thumbnail: String
      ) {
        saveTemplate(
          input: {
            id: $id
            themeId: $themeId
            version: $version
            content: $content
            type: $type
            name: $name
            width: $width
            height: $height
            team: $team
            thumbnail: $thumbnail
          }
        ) {
          success
          template {
            id
            type
            name
            hash
          }
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      id,
      themeId,
      version,
      content,
      type,
      name,
      width,
      height,
      team,
      thumbnail,
    },
  });

export const updateTemplateMutation = (id, themeId, type, name) =>
  client.mutate({
    mutation: gql`
      mutation updateTemplate(
        $id: UUID!
        $themeId: UUID
        $type: TemplateType!
        $name: String
      ) {
        updateTemplate(
          input: { id: $id, themeId: $themeId, type: $type, name: $name }
        ) {
          success
          template {
            id
            type
            name
            content
            version
            width
            height
          }
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      id,
      themeId,
      type,
      name,
    },
  });

export const deleteTemplateMutation = id =>
  client.mutate({
    mutation: gql`
      mutation deleteTemplate($id: UUID!) {
        deleteTemplate(input: { id: $id }) {
          success
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      id,
    },
  });

export const createThemeMutation = (name, description = '', team) =>
  client.mutate({
    mutation: gql`
      mutation createTheme($name: String!, $description: String, $team: UUID) {
        createTheme(
          input: { name: $name, description: $description, team: $team }
        ) {
          success
          theme {
            id
            name
            default
            permissions
          }
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      name,
      description,
      team,
    },
  });

export const updateThemeMutation = (id, name, description = '', order) =>
  client.mutate({
    mutation: gql`
      mutation updateTheme(
        $id: UUID!
        $name: String
        $description: String
        $order: [String]
      ) {
        updateTheme(
          input: {
            id: $id
            name: $name
            description: $description
            order: $order
          }
        ) {
          success
          theme {
            id
            name
            default
            permissions
          }
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      id,
      name,
      description,
      order,
    },
  });

export const deleteThemeMutation = id =>
  client.mutate({
    mutation: gql`
      mutation deleteTheme($id: UUID!) {
        deleteTheme(input: { id: $id }) {
          success
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      id,
    },
  });

export const launchVideoExportMutation = (presentation, delay, team) =>
  client.mutate({
    mutation: gql`
      mutation launchVideoExport(
        $presentation: UUID!
        $delay: Int
        $team: UUID
      ) {
        launchVideoExport(
          input: { presentation: $presentation, delay: $delay, team: $team }
        ) {
          success
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      presentation,
      delay,
      team,
    },
  });

export const deleteGoogleFontMutation = id =>
  client.mutate({
    mutation: gql`
      mutation deleteGoogleFont($id: UUID!) {
        deleteGoogleFont(input: { id: $id }) {
          success
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      id,
    },
  });

export const deleteFontMutation = id =>
  client.mutate({
    mutation: gql`
      mutation deleteFont($id: UUID!) {
        deleteFont(input: { id: $id }) {
          success
          validationErrors {
            field
            code
            message
            extra
          }
        }
      }
    `,
    variables: {
      id,
    },
  });
